import React, { useState, useEffect } from 'react';

/**
 * Animated waveform visualization with ClariMe brand colors.
 * Accepts audioLevel (0-1) for real audio visualization.
 */
const Waveform = ({ isRecording, audioLevel = 0 }) => {
  const [bars, setBars] = useState(Array(24).fill(8));

  useEffect(() => {
    if (isRecording) {
      const interval = setInterval(() => {
        const baseHeight = 12;
        const maxVariation = 52;
        const amplifiedLevel = Math.min(1, audioLevel * 3);
        const levelMultiplier = Math.max(0.3, amplifiedLevel);

        setBars(Array(24).fill(0).map((_, i) => {
          const waveOffset = Math.sin(Date.now() / 200 + i * 0.3) * 0.3;
          const variation = (Math.random() * 0.7 + 0.3 + waveOffset) * maxVariation * levelMultiplier;
          return baseHeight + variation;
        }));
      }, 80);
      return () => clearInterval(interval);
    } else {
      setBars(Array(24).fill(8));
    }
  }, [isRecording, audioLevel]);

  return (
    <div className="flex items-center justify-center gap-1 h-20">
      {bars.map((height, i) => (
        <div
          key={i}
          className="w-1.5 rounded-full transition-all duration-75"
          style={{ height: `${height}px`, background: `linear-gradient(to top, #14b8a6, #06b6d4)` }}
        />
      ))}
    </div>
  );
};

export default Waveform;
